<hr>
<footer>
    <p class="text-center p-4 m-0">
        copyright © {{currentYear}}. All rights reserved to {{settings?.Name || "Apostille"}} {{settings?.TLD || "com"}}
    </p>
</footer>